<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '900px', maxWidth: '95vw'}"
  styleClass="p-fluid lista-file-dialog"
  [showHeader]="false"
  (onShow)="onShow()"
  (onHide)="onHide()">

  <div class="dialog-container">
    <!-- Header del dialog -->
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-list header-icon"></i>
        <h2>
          <span *ngIf="rendicontazione?.tipo?.descrizione === 'ACCONTO'">Allegati dell'ACCONTO</span>
          <span *ngIf="rendicontazione?.tipo?.descrizione === 'SALDO'">Allegati del SALDO</span>
          <span *ngIf="rendicontazione?.tipo?.descrizione !== 'ACCONTO' && rendicontazione?.tipo?.descrizione !== 'SALDO'">
            Allegati della Rendicontazione {{ rendicontazione?.tipo?.descrizione | uppercase }}
          </span>
          dell'intervento
        </h2>
        <div *ngIf="intervento?.scheda?.vecchioCodiceUmvs" class="code-badge legacy-code" style="background-color: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem; border-left: 3px solid #8f5cb7;">
          <span class="code-value" style="font-weight: bold; color: #8B4513; " pTooltip="VECCHIO CODICE UMVS" tooltipPosition="top">{{ intervento?.scheda?.vecchioCodiceUmvs }}</span>
         </div>
         <div class="code-badge" style="background-color: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem; border-left: 3px solid #4285F4;">
           <span class="code-value" style="font-weight: bold; color: #3a6e75;" pTooltip="NUOVO CODICE" tooltipPosition="top">{{ intervento?.scheda?.codice }}</span>
         </div>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="onHide()">
      </button>
    </div>

    <!-- Contenuto principale -->
    <div class="dialog-content">
      <!-- Info rendicontazione -->
      <div class="rendicontazione-info" *ngIf="rendicontazione">
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Tipo:</span>
            <span class="badge" [ngClass]="{
              'badge-acconto': rendicontazione.tipo.descrizione === 'ACCONTO',
              'badge-saldo': rendicontazione.tipo.descrizione === 'SALDO'
            }">
              {{ rendicontazione.tipo.descrizione }}
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">Importo:</span>
            <span class="importo">{{ rendicontazione.importo | currency:'EUR':'':'1.2-2':'it-IT' }}</span>
          </div>
          <div class="info-item" *ngIf="rendicontazione.creata">
            <span class="info-label">Data:</span>
            <span>{{ rendicontazione.creata | date:'dd/MM/yyyy' }}</span>
          </div>
        </div>
      </div>

      <p-divider></p-divider>

      <!-- Loading state -->
      <div *ngIf="isLoading" class="loading-container">
        <ng-lottie [options]="options" width="200px" height="200px"></ng-lottie>
        <p>Lettura cartella in corso...</p>
      </div>

      <!-- Tabella file -->
      <div *ngIf="!isLoading">
        <!-- <div class="files-summary" *ngIf="files.length > 0">
          <span class="summary-text">
            <i class="pi pi-info-circle"></i>
            Trovati {{ files.length }} file{{ files.length === 1 ? '' : 's' }}
          </span>
        </div> -->

        <p-table
          *ngIf="files.length > 0"
          [value]="files"
          styleClass="p-datatable-sm files-table"
          [scrollable]="true"
          scrollHeight="400px"
          [rows]="10"
          [paginator]="files.length > 10"
          [showCurrentPageReport]="files.length > 10"
          currentPageReportTemplate="Mostra {first} - {last} di {totalRecords} file">

          <ng-template pTemplate="header">
            <tr>
                <th style="width: 8%">Tipo</th>
                <th style="width: 47%">Nome File</th>
             <!--   <th style="width: 15%">Categoria</th> -->
                                 <th style="width: 15%" >Dimensione</th>
                 <th style="width: 20%; text-align: center;">Data Caricamento</th>
                 <th style="width: 5%; text-align: center;"></th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-file>
            <tr>
              <td class="text-center">
                <i [class]="'pi ' + getFileIcon(file.tipo)"
                   [style.color]="file.tipo === 'PDF' ? '#e74c3c' :
                                  file.tipo === 'Word' ? '#2980b9' :
                                  file.tipo === 'Excel' ? '#27ae60' :
                                  file.tipo === 'Immagine' ? '#f39c12' :
                                  file.tipo === 'Firmato' ? '#8e44ad' : '#34495e'"
                   style="font-size: 1.2rem;"
                   [pTooltip]="file.tipo"
                   tooltipPosition="top">
                </i>
              </td>
              <td>
                <div class="file-name-container">
                  <span class="file-name" [pTooltip]="file.nome" tooltipPosition="top">
                    {{ file.nome }}
                  </span>
                </div>
              </td>
             <!--  <td>
                <div class="categoria-container">
                  <i [class]="'pi ' + getCategoriaIcon(file.categoria)"
                     style="margin-right: 0.5rem; color: #666;"></i>
                  <span class="categoria-label">{{ getCategoriaLabel(file.categoria) }}</span>
                </div>
              </td> -->
                <td class="text-center file-size-cell">
                  <div class="file-size-container">
                    <span class="file-size">{{ formatFileSize(file.dimensione) }}</span>
                  </div>
                </td>
              <td class="text-center">
                <div class="date-container">
                  <span *ngIf="file.dataCaricamento" class="file-date">
                    {{ file.dataCaricamento | date:'dd/MM/yy HH:mm' }}
                  </span>
                  <span *ngIf="!file.dataCaricamento" class="no-date">-</span>
                </div>
              </td>
              <td class="text-center">
                <div class="action-buttons">
                  <button
                    pButton
                    type="button"
                    icon="pi pi-download"
                    class="p-button-rounded p-button-text p-button-sm p-button-info"
                    (click)="scaricaFile(file)"
                    [pTooltip]="'Scarica ' + file.nome"
                    tooltipPosition="top">
                  </button>

                  <button
                    pButton
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-text p-button-sm p-button-danger"
                    (click)="mostraConfermaEliminazioneFile(file)"
                    [pTooltip]="'Elimina ' + file.nome"
                    tooltipPosition="top">
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center empty-message">
                <div class="empty-state">
                  <i class="pi pi-inbox" style="font-size: 3rem; color: #ccc; margin-bottom: 1rem;"></i>
                  <h4>Nessun file trovato</h4>
                  <p>Non sono stati trovati file per questa rendicontazione.</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- Empty state quando non ci sono file (solo dopo il caricamento) -->
        <div *ngIf="files.length === 0 && hasLoadedOnce" class="empty-state-main">
          <i class="pi pi-inbox"></i>
          <h3>Nessun file caricato</h3>
          <p>Non sono stati ancora caricati file per questa rendicontazione.</p>
        </div>
      </div>
    </div>

    <!-- Footer del dialog -->
    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="onHide()">
      </button>
    </div>
  </div>
</p-dialog>

<!-- Toast per messaggi -->
<p-toast position="top-right"></p-toast>

<!-- Modale di conferma eliminazione singolo file -->
<p-dialog
  [(visible)]="showConfermaEliminazioneSingoloFile"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="!eliminazioneSingoloFileInCorso"
  [dismissableMask]="!eliminazioneSingoloFileInCorso"
  [style]="{width: '500px', maxWidth: '100vw'}"
  styleClass="p-fluid conferma-eliminazione-file-dialog"
  [showHeader]="false"
  (onHide)="onHideConfermaEliminazioneSingoloFile()">

  <div class="dialog-container">
    <!-- Header del dialog -->
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-trash header-icon"></i>
        <h2>Conferma Eliminazione File</h2>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        [disabled]="eliminazioneSingoloFileInCorso"
        (click)="onHideConfermaEliminazioneSingoloFile()">
      </button>
    </div>

    <!-- Contenuto principale -->
    <div class="dialog-content" *ngIf="fileSelezionatoPerEliminazione">
      <div class="flex justify-content-center mb-3">
        <i class="pi pi-exclamation-triangle warning-icon"></i>
      </div>

      <h3>Sei sicuro di voler eliminare questo file?</h3>

      <div class="intervento-info">
        <p-divider></p-divider>
        <div class="info-row">
          <div class="info-label">File:</div>
          <div class="info-value">
            <span class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px;">
              <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ fileSelezionatoPerEliminazione.nome }}</span>
            </span>
          </div>
        </div>

        <div class="info-row">
          <div class="info-label">Tipo:</div>
          <div class="info-value">
            <i [class]="'pi ' + getFileIcon(fileSelezionatoPerEliminazione.tipo)"
               [style.color]="fileSelezionatoPerEliminazione.tipo === 'PDF' ? '#e74c3c' :
                              fileSelezionatoPerEliminazione.tipo === 'Word' ? '#2980b9' :
                              fileSelezionatoPerEliminazione.tipo === 'Excel' ? '#27ae60' :
                              fileSelezionatoPerEliminazione.tipo === 'Immagine' ? '#f39c12' :
                              fileSelezionatoPerEliminazione.tipo === 'Firmato' ? '#8e44ad' : '#34495e'"
               style="margin-right: 0.5rem;"></i>
            {{ fileSelezionatoPerEliminazione.tipo }}
          </div>
        </div>

        <div class="info-row">
          <div class="info-label">Dimensione:</div>
          <div class="info-value">{{ formatFileSize(fileSelezionatoPerEliminazione.dimensione) }}</div>
        </div>

        <div class="info-row" *ngIf="fileSelezionatoPerEliminazione.categoria">
          <div class="info-label">Categoria:</div>
          <div class="info-value">
            <span class="badge" [ngClass]="{
              'badge-acconto': fileSelezionatoPerEliminazione.categoria === 'rendicontazione',
              'badge-saldo': fileSelezionatoPerEliminazione.categoria === 'determina'
            }">
              {{ getCategoriaLabel(fileSelezionatoPerEliminazione.categoria) }}
            </span>
          </div>
        </div>

        <div class="info-row" *ngIf="fileSelezionatoPerEliminazione.dataCaricamento">
          <div class="info-label">Data:</div>
          <div class="info-value">{{ fileSelezionatoPerEliminazione.dataCaricamento | date:'dd/MM/yyyy' }}</div>
        </div>
      </div>

      <div class="warning-message">
        <i class="pi pi-info-circle"></i>
        <span>Questa azione non può essere annullata e rimuoverà definitivamente questo file dal sistema.</span>
      </div>

    </div>

    <!-- Footer del dialog -->
    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        [disabled]="eliminazioneSingoloFileInCorso"
        (click)="annullaSingoloFile()">
      </button>
      <button
        pButton
        pRipple
        label="Elimina File"
        icon="pi pi-trash"
        class="p-button-danger"
        [loading]="eliminazioneSingoloFileInCorso"
        (click)="confermaEliminazioneSingoloFile()">
      </button>
    </div>
  </div>
</p-dialog>
